var React = require('react');

var ResponsiveImage = React.createClass({
    render: function(){
        var url = this.props.url || '#';
        var image = this.props.image || {};
        var imageUrl = image.url || '';
        var imgPath = imageUrl.split('http://a.espncdn.com')[1];
        var credit = image.credit || '';
        
        var html = 
            '<a name="&amp;lpos=" class="img-wrap" href="' + url + '" data-sport="rugby">' +
                '<picture>' +
                    '<!--[if IE 9]><video style="display: none;"><![endif]-->' +
                    '<source srcset="http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=78&amp;h=78&amp;scale=crop&amp;cquality=90&amp;location=center, http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=156&amp;h=156&amp;scale=crop&amp;cquality=90&amp;location=center 2x" data-srcset="http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=78&amp;h=78&amp;scale=crop&amp;cquality=90&amp;location=center, http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=156&amp;h=156&amp;scale=crop&amp;cquality=90&amp;location=center 2x" media="(max-width: 413px)">' +
                    '<source srcset="http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=272&amp;h=153&amp;scale=crop&amp;cquality=90&amp;location=origin, http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=544&amp;h=306&amp;scale=crop&amp;cquality=90&amp;location=origin 2x" data-srcset="http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=272&amp;h=153&amp;scale=crop&amp;cquality=90&amp;location=origin, http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=544&amp;h=306&amp;scale=crop&amp;cquality=90&amp;location=origin 2x" media="(min-width: 414px)">' +
                    '<!--[if IE 9]></video><![endif]-->' +
                    '<img src="http://a4.espncdn.com/combiner/i?img=' + imgPath + '&amp;w=544&amp;h=306&amp;scale=crop&amp;cquality=90&amp;location=origin" data-default-src="' + imageUrl + '" class=" imageLoaded lazyloaded" data-image-container=".feed-item-figure" width="272">' +
                '</picture>' +
            '</a>' +
            '<span class="credit">' + credit + '</span>';
        
        return (
            <figure className="feed-item-figure " dangerouslySetInnerHTML={{__html: html}}>
            </figure>
        );
    }
});

module.exports = ResponsiveImage;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/common/ResponsiveImage.jsx
 **/